// src/components/Themes.js
export const lightTheme = {
  body: '#f9f9f9',
  text: '#333',
  primary: '#3a86ff',
  secondary: '#8338ec',
  accent: '#ff006e',
  background: '#ffffff',
  cardBg: '#ffffff',
  cardShadow: '0 10px 30px -15px rgba(0,0,0,0.2)',
  navBg: 'rgba(255,255,255,0.8)',
  navShadow: '0 2px 10px rgba(0,0,0,0.1)',
  toggleBorder: '#fff',
  gradient: 'linear-gradient(135deg, #3a86ff 0%, #8338ec 100%)',
};

export const darkTheme = {
  body: '#121212',
  text: '#f9f9f9',
  primary: '#3a86ff',
  secondary: '#8338ec',
  accent: '#ff006e',
  background: '#1e1e1e',
  cardBg: '#2d2d2d',
  cardShadow: '0 10px 30px -15px rgba(0,0,0,0.5)',
  navBg: 'rgba(30,30,30,0.8)',
  navShadow: '0 2px 10px rgba(0,0,0,0.3)',
  toggleBorder: '#6B8096',
  gradient: 'linear-gradient(135deg, #3a86ff 0%, #8338ec 100%)',
};